import { Injectable } from "@angular/core";
import { Company } from "../../models/domains/pbm/companies/company";
import { UserService } from "../user.service";
import { SelectionModel } from "@angular/cdk/collections";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

export interface GeneralReportFilters {
  startAt: string;
  endAt: string;
  fiscalNumber: string;
}

@Injectable({ providedIn: "root" })
export class GeneralReportService {

  private allowedCompanies = new MatTableDataSource<Company>();
  private selectedCompanies = new SelectionModel<Company>(true, []);
  private filters: GeneralReportFilters = { startAt: "", endAt: "", fiscalNumber: "" };
  private intervalHandle: any;

  constructor(
    private userService: UserService
  ) { }

  getAllowedCompanies(): MatTableDataSource<Company> {
    return this.allowedCompanies;
  }

  getSelectedCompanies(): SelectionModel<Company> {
    return this.selectedCompanies;
  }

  getFilters(): GeneralReportFilters {
    return this.filters;
  }

  sortTable(sort: MatSort): void {
    if (sort.direction === "asc") {
      this.allowedCompanies.data = this.allowedCompanies.data.sort((a, b) => {
        if (this.getIsSelected(a) !== -1 && !(this.getIsSelected(b) !== -1)) {
          return -1;
        } else if (this.getIsSelected(b) !== -1 && !(this.getIsSelected(a) !== -1)) {
          return 1;
        }
      });
    } else if (sort.direction === "desc") {
      this.allowedCompanies.data = this.allowedCompanies.data.sort((a, b) => {
        if (this.getIsSelected(a) !== -1 && !(this.getIsSelected(b) !== -1)) {
          return 1;
        } else if (this.getIsSelected(b) !== -1 && !(this.getIsSelected(a) !== -1)) {
          return -1;
        }
      });
    } else {
      this.allowedCompanies.data = this.allowedCompanies.data.sort((a, b) => {
        if (a.getCorporateName() === b.getCorporateName()) {
          return Number.parseInt(a.getFiscalNumber()) - Number.parseInt(b.getFiscalNumber());
        }
        return a.getCorporateName() > b.getCorporateName() ? 1 : -1;
      });
    }
  }

  filterAllowedCompanies(paginator: MatPaginator): void {
    this.allowedCompanies.data = this.userService
      .getLoggedUser()
      .getAllowedCompanies()
      .filter((ac) => {
        return ac.getFiscalNumber().substr(0, 8) === this.filters.fiscalNumber.replace(/[./-]/g, "").substr(0, 8) || this.filters.fiscalNumber === "";
      });

    this.allowedCompanies.paginator = paginator;
  }

  clearAllowedCompanies(): void {
    clearInterval(this.intervalHandle);
    this.allowedCompanies.data = [];
    this.selectedCompanies.clear();
    this.filters = { startAt: "", endAt: "", fiscalNumber: "" };
  }

  isAllSelected(): boolean {
    const numSelected = this.selectedCompanies.selected.length;
    const numRows = this.allowedCompanies.data.length;
    return numSelected === numRows;
  }

  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selectedCompanies.clear();
      return;
    }
    this.selectedCompanies.clear();
    this.allowedCompanies.data.forEach((company) => {
      this.selectedCompanies.selected.push(company);
    });
  }

  selectCompany(event: any, element: Company, sort: MatSort): void {
    const idx = this.getIsSelected(element);
    if (idx == -1) {
      this.selectedCompanies.selected.push(element);
    } else {
      this.selectedCompanies.selected.splice(idx, 1);
    }
    this.allowedCompanies.sort = sort;
  }

  /**
   * O método nativo this.selectedCompanies.isSelected(element) não funciona neste contexto pois
   * ele faz referência a objetos. Quando os dados de "allCompanies" eram atualizados, perdiam-se
   * as referências dos objetos selecionados mesmo ainda estando na lista "selectedCompanies".
   * Faz a busca "manualmente" verificando pelo identificador fiscalNumber (CNPJ).
   * @param element Company this.selectedCompanies.
   * @returns índice do elemento. Se não encontrar, retorna -1
   */
  getIsSelected(element: Company): number {
    let ret = -1;
    for (let i = 0; i < this.selectedCompanies.selected.length; i++) {
      const selected = this.selectedCompanies.selected[i];
      if (element.getFiscalNumber() === selected.getFiscalNumber()) {
        ret = i;
        break;
      }
    }
    return ret;
  }
}
